
import AppLogoSettings from "./LogoSettings.vue";
import AppPageSettings from "./PageSettings.vue";
import AppTab from "@/components/layout-editor/Tab.vue";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import Vue from "vue";
import AppDetailSettings from "./DetailSettingsTab.vue";
import AppFreeLines from "./FreeLines.vue";
import AppHeadingSettings from "./HeadingSettings.vue";
import AppRequirementSettings from "./RequirementSettings.vue";
import AppTableLineSettings from "./TableLineSettings.vue";
import AppTextSettings from "./TextSettings.vue";
import AppTotalsSettings from "./TotalsSettings.vue";
import AppVatSettings from "./VatSettings.vue";
import AppAttachmentSettings from "./AttachmentSettings.vue";
import AppFreeBlocksSettings from "./FreeBlocksSettings.vue";
import AppPdfPreview from "./PdfPreview.vue";
import AppQrSettings from "./QrSettings.vue";
import AppBarcodeSettings from "./BarcodeSettings.vue";
import AppPaymentSettings from "./PaymentSettings.vue";
import { FreeBlock } from "@/utils/documents/free-block";

export default Vue.extend({
	data(){
		return {
			toEditFreeBlock: null as null | FreeBlock
		};
	},
	props: {
		tab: Number,
		layout: {
			type: Object as () => SaleLayout,
			required: true
		},
		fullControl: Boolean,
		contactGroupId: {
			type: Number,
			required: true
		}
	},
	watch: {
		tab: {
			handler(){
				if (this.tab != 9){
					this.toEditFreeBlock = null;
				}
			}
		}
	},
	methods: {
		async onOpenFreeBlock(block:FreeBlock){
			this.toEditFreeBlock = block;
			this.$emit("update:tab", 9);
		}
	},
	components: {
		AppPageSettings,
		AppHeadingSettings,
		AppDetailSettings,
		AppTotalsSettings,
		AppRequirementSettings,
		AppLogoSettings,
		AppTextSettings,
		AppTableLineSettings,
		AppFreeLines,
		AppTab,
		AppAttachmentSettings,
		AppFreeBlocksSettings,
		AppPdfPreview,
		AppVatSettings,
		AppQrSettings,
		AppBarcodeSettings,
		AppPaymentSettings
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
